import ProductCmsPage from "components/cms/ProductCmsPage";
import {
  addProductPageThree,
  getProductPageThree,
  prepareProductPageThree,
  updateProductPageThree,
} from "api/productpagethree";
import { emptyProductsThree } from "utils/defaults";

export default function ProductsThreePage() {
  return (
    <ProductCmsPage
      label="Product three"
      heading="Product three"
      description="/products/three"
      idPrefix="products-three"
      load={getProductPageThree}
      create={addProductPageThree}
      update={updateProductPageThree}
      empty={emptyProductsThree}
      prepare={prepareProductPageThree}
    />
  );
}
